import { makeTAddIsNotMoralOrIgnored } from '../../TYPE/logic';
export var showLogic = makeTAddIsNotMoralOrIgnored({});
